var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-details",on:{"click":function($event){$event.preventDefault();return _vm.clicked($event)}}},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"order-from-restaurant"},[_vm._v(_vm._s(_vm.orderDetails.restaurantName))]),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.dateToDisplay()))]),_c('div',{staticClass:"total-price"},[_vm._v("S$"+_vm._s(_vm.orderDetails.totalPrice))])]),_c('div',{staticClass:"right"},[_c('div',{staticClass:"status-button",class:{
        delivered: _vm.orderDetails.delivered,
        pending:
          _vm.orderDetails.acceptedBySaviour &&
          !_vm.orderDetails.delivered &&
          !_vm.orderDetails.cancelled,
        cancelled: _vm.orderDetails.cancelled,
        processing:
          !_vm.orderDetails.acceptedBySaviour &&
          !_vm.orderDetails.delivered &&
          !_vm.orderDetails.cancelled,
      }},[(_vm.orderDetails.delivered)?_c('span',[_vm._v("Delivered")]):(
          _vm.orderDetails.acceptedBySaviour &&
            !_vm.orderDetails.delivered &&
            !_vm.orderDetails.cancelled
        )?_c('span',[_vm._v("Delivering")]):(_vm.orderDetails.cancelled)?_c('span',[_vm._v("Cancelled")]):_c('span',[_vm._v("Processing")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }